import React, { useEffect, useState, useRef } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Radio from '@material-ui/core/Radio';
import * as storage from '@storage'
import * as slipCode from '@scripts/SlipConfigurationCode'
import * as communicationCode from '@scripts/CommunicationTypeCode'
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import styles from '@styles/profile.module.css';
import { saveAdditionalInformation, getInfoEmployee, loadAdditionalCombos } from '@actions/myFile/profile';
import * as StatusCode from '@scripts/StatusCode';
import AlertAlgo from '@controls/AlertSnack'
import LoadingLayer from '@controls/LoadingLayer';
import { withNamespaces } from 'react-i18next';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { IsEnglish } from '@utils/language';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles((theme) => ({
    rootProfile: {
        overflow: 'auto',
        padding: '15px'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    rootTable: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& td:first-child': {
            width: '30%'
        },
    },
    formControl: {
        paddingLeft: '9px',
        '& span': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& input': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        marginBottom: 'unset !important',
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
    formControlReserve: {
        paddingLeft: '0px',
        '& span': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& input': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        marginBottom: 'unset !important'
    },
    labelMulti: {
        paddingTop: '5px',
        paddingBottom: '2px',
        marginBottom: '0'
    }
}));

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bolder',
        width: '25%',
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    }
}))(TableCell);

const GreenRadio = withStyles({
    root: {
        color: 'black',
        '&$checked': {
            color: 'var(--color1)',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

function AdditionalInfoForm(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [language, setLanguage] = useState(data.employee?.language);
    const [receiptSlips, setReceiptSlips] = useState('');
    const [communicationPreference, setCommunicationPreference] = useState('');
    const [flagReceiptSlips, setFlagReceiptSlips] = useState(storage.getDisplayDistributionSlip());
    const [flagCommunicationPreference, setFlagCommunicationPreference] = useState(storage.getDisplayPreferenceCommunication());
    const [flagFullTime, setFlagFullTime] = useState(storage.getDisplayFlagFullTime());
    const [isProcessing, setIsProcessing] = useState(true);
    const [listComplete, setListComplete] = useState([]);
    const [availabilities, setAvailbilites] = useState([]);
    const [regions, setRegions] = useState([]);
    const [availableFullTime, setAvailableFullTime] = useState(false);
    const [isReserve, setIsReserve] = useState(false);
    const [availabilityValueList, setAvailabilityValueList] = useState([]);
    const [regionValueList, setRegionValueList] = useState([]);
    const [fullTimeData, setFullTimeData] = useState(null);
    const [onCall, setOnCall] = useState(false);
    const [openConfirmationOnCall, setOpenConfirmationOnCall] = useState(false);

    const alertRef = useRef(null);
    const availabilitiesSelected = availabilityValueList.length;
    const regionSelected = regionValueList.length;
    const flagOnCall = storage.getIsOnCallFlag();

    useEffect(() => {
        async function load() {
            await loadEmployeeInfo();
            await loadDropDowns();
            resize();
        }
        load();
    }, []);

    useEffect(() => {
        handleDataChanged();
    }, [language, isReserve, availableFullTime, regionValueList, availabilityValueList]);

    useEffect(() => {
        async function load() {
            const obj = await manageFullTime();
            await loadAvailabilities(obj.availability);
            await loadRegions(obj.region);  
        }

        if (listComplete.regions?.length > 0 && flagFullTime) {
            load();
            handleDataChanged();
        }
    }, [listComplete, fullTimeData]);

    useEffect(() => {
        if (data.employee?.distriTypeSlip != null) {
            setLanguage(data.employee.language);

            if (flagReceiptSlips) {
                setReceiptSlips(getDescriptionSlip());
            }

            if (flagCommunicationPreference) {
                setCommunicationPreference(getDescriptionCommunication());
            }
            
            handleDataChanged();
        }
    }, [data]);

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = 50;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divProfile');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 0);
    }

    const loadEmployeeInfo = () => {
        getInfoEmployee().then(response => {
            setData({
                employee: response.employee,
                onCall: response.isOnCall
            });
            //setData(response.employee);
            setFullTimeData(response.fullTimeMonitoring);
            setOnCall(response.isOnCall);
            setIsProcessing(false);
        });
    }
    
    const manageFullTime = () => {
        if (fullTimeData != null && fullTimeData.employeeCode != null) {
            setAvailableFullTime(true);
            setIsReserve(fullTimeData.isReserve);

            const availabilitySplit = fullTimeData.availability?.split(',');
            const regionSplit = fullTimeData.workRegion?.split(',');

            const obj = {
                availability: availabilitySplit,
                region: regionSplit
            };

            return obj;
        } else {
            const obj = {
                availability: null,
                region: null
            };
            return obj;
        }
    }

    const handleLanguage = (event) => {
        setLanguage(event.target.value);
    }

    const handleDataChanged = () => {
        props.handleDataChanged(isDataChanged());
    }

    const parentHandleReload = () => {
        props.handleReload();
    }

    const isDataChanged = () => {
        const originalData = data;
        const isValid = originalData?.employee?.language != language;
        ////const isValid = originalData.language != language;

        let isValidAvail = false;
        if (((fullTimeData?.availability?.split(',') == undefined || fullTimeData?.availability == null) && getAvailabilityValue() !== "") || 
            (!(fullTimeData?.availability?.split(',') == undefined || fullTimeData?.availability == null) && fullTimeData?.availability?.split(',').toString() != getAvailabilityValue()))
        {
            isValidAvail = true;
        }

        let isValidRegion = false;
        if (((fullTimeData?.workRegion?.split(',') == undefined || fullTimeData?.workRegion == null) && getRegionValue() !== "") ||
            (!(fullTimeData?.workRegion?.split(',') == undefined || fullTimeData?.workRegion == null) && fullTimeData?.workRegion?.split(',').toString() != getRegionValue())) {
            isValidRegion = true;
        }

        const isValidFull = fullTimeData?.isReserve != isReserve || isValidAvail || isValidRegion;

        let isValidOnCall = false;
        if (flagOnCall) {
            isValidOnCall = originalData?.onCall != onCall;
        }

        return flagFullTime ? (isValid || isValidFull || isValidOnCall) : isValid || isValidOnCall;
    }

    const getRegionValue = () => {
        return regionValueList.filter((v) => v.regionCode !== "%")?.map((x) => x.regionCode).toString() ?? ""; 
    }

    const getAvailabilityValue = () => {
        return availabilityValueList.filter((v) => v.availabilityCode !== "%")?.map((x) => x.availabilityCode).toString() ?? "";
    }

    const isValidData = () => {
        let message = '';

        if (!isDataChanged()) {
            message = i18next.t('profile:message.noModification');
        } else {
            if (flagFullTime && availableFullTime) {
                const availValue = getAvailabilityValue();
                const regiValue = getRegionValue();

                if (availValue === "") {
                    message = i18next.t('profile:additionalInformation.message.availabilityEmpty');
                } else if (regiValue === "") {
                    message = i18next.t('profile:additionalInformation.message.regionEmpty');
                }
            }
        }

        if (message.length > 0) {
            showMessageError(message);
            return false;
        }

        return true;
    }

    const handleSave = () => {
        if (isValidData()) {
            saveAdditionalInformation(language, flagFullTime, availableFullTime, getAvailabilityValue(), getRegionValue(), isReserve, flagOnCall, onCall).then(response => {
                if (response != null && response.status == StatusCode.STATUS_OK) {
                    showMessageSuccess(i18next.t('profile:additionalInformation.message.success'));
                    loadEmployeeInfo();
                    parentHandleReload();
                    return;
                }
                showMessageError(i18next.t('error:generic-error'));
            });
            props.handleDataChanged(false);
        }
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const handleAvailableFullTimeClick = () => {
        const fullTimeValue = !availableFullTime;

        setAvailabilityValueList([]);
        setRegionValueList([]);
        setIsReserve(false);

        setAvailableFullTime(fullTimeValue);
    };

    const handleOnCallClick = () => {
        setOpenConfirmationOnCall(true);

    }

    const handleCloseConfirmOnCall = () => {
        setOpenConfirmationOnCall(false);
    }

    const handleConfirmOnCallClick = () => {
        const isOnCall = !onCall;

        setOnCall(isOnCall);
        setOpenConfirmationOnCall(false);
    }
    
    const handleIsReserveClick = () => {
        let isReserveValue = !isReserve;
        setIsReserve(isReserveValue);
    };

    const getDescriptionSlip = () => {
        let slipDescription = '';

        switch (data.employee.distriTypeSlip) {
            case slipCode.Slip_Print:
                slipDescription = i18next.t('profile:additionalInformation.slipConfig.print');
                break;
            case slipCode.Slip_Email:
                slipDescription = i18next.t('profile:additionalInformation.slipConfig.email');
                break;
            case slipCode.Slip_Portal:
                slipDescription = i18next.t('profile:additionalInformation.slipConfig.portal');
                break;
            case slipCode.Slip_PrintEmail:
                slipDescription = i18next.t('profile:additionalInformation.slipConfig.printEmail');
                break;
            case slipCode.Slip_PrintPortal:
                slipDescription = i18next.t('profile:additionalInformation.slipConfig.printPortal');
                break;
            case slipCode.Slip_PrintEmailPortal:
                slipDescription = i18next.t('profile:additionalInformation.slipConfig.printEmailPortal');
                break;
            case slipCode.Slip_EmailPortal:
                slipDescription = i18next.t('profile:additionalInformation.slipConfig.emailPortal');
                break;
        }

        return slipDescription;
    }

    const getDescriptionCommunication = () => {
        let communicationDescription = '';

        switch (data.employee.communicMethod) {
            case communicationCode.Communication_Portal:
                communicationDescription = i18next.t('profile:additionalInformation.communicationType.portal');
                break;
            case communicationCode.Communication_PortalAndEmail:
                communicationDescription = i18next.t('profile:additionalInformation.communicationType.portalEmail');
                break;
            case communicationCode.Communication_SMS:
                communicationDescription = i18next.t('profile:additionalInformation.communicationType.sms');
                break;
            case communicationCode.Communication_Both:
                communicationDescription = i18next.t('profile:additionalInformation.communicationType.both');
                break;
        }

        return communicationDescription;
    }

    const manageAvailabilityChange = (eventValue, availabilityValueListTemp) => {
        const list = availabilityValueListTemp ?? availabilityValueList;
        const currentSelectAll = list.some((i) => i.availabilityCode === "%");
        const nextSelectAll = eventValue.some((i) => i.availabilityCode === "%");
        const currentCount = list.length;
        const nextCount = eventValue.length;

        if (availabilityValueListTemp == null) {
            if (nextCount > currentCount && !currentSelectAll && !nextSelectAll && availabilities.length - 1 === nextCount) {
                eventValue = availabilities;
            } else if (nextCount < currentCount && currentCount === availabilities.length && currentSelectAll && nextSelectAll) {
                eventValue = eventValue.filter((v) => v.availabilityCode !== "%");
            } else if (!currentSelectAll && nextSelectAll) {
                eventValue = availabilities;
            } else if (currentSelectAll && !nextSelectAll) {
                eventValue = [];
            }
        } else {
            if (nextCount === availabilityValueListTemp.length - 1) {
                eventValue = availabilityValueListTemp;
            } else {
                eventValue = eventValue.filter((v) => v.availabilityCode !== "%");
            }
        }
        
        setAvailabilityValueList(eventValue);
    }

    const onAvailabilityChange = (event) => {
        manageAvailabilityChange(event.value);
    };

    const manageRegionChange = (eventValue, regionValueListTemp) => {
        const list = regionValueListTemp ?? regionValueList;
        const currentSelectAll = list.some((i) => i.regionCode === "%");
        const nextSelectAll = eventValue.some((i) => i.regionCode === "%");
        const currentCount = list.length;
        const nextCount = eventValue.length;

        if (regionValueListTemp == null) {
            if (nextCount > currentCount && !currentSelectAll && !nextSelectAll && regions.length - 1 === nextCount) {
                eventValue = regions;
            } else if (nextCount < currentCount && currentCount === regions.length && currentSelectAll && nextSelectAll) {
                eventValue = eventValue.filter((v) => v.regionCode !== "%");
            } else if (!currentSelectAll && nextSelectAll) {
                eventValue = regions;
            } else if (currentSelectAll && !nextSelectAll) {
                eventValue = [];
            }
        } else {
            if (nextCount === regionValueListTemp.length - 1) {
                eventValue = regionValueListTemp;
            } else {
                eventValue = eventValue.filter((v) => v.regionCode !== "%");
            }
        }

        setRegionValueList(eventValue);
    }

    const onRegionChange = (event) => {
        manageRegionChange(event.value);
    };

    const loadDropDowns = async () => {
        var response = await loadAdditionalCombos();

        if (response != null) {
            setListComplete(JSON.parse(response.result));
        }
        else {
            this.showMessageError(i18next.t('error:generic-error'));
        }
    };

    const loadAvailabilities = (availabilitySplit) => {
        return new Promise(async (resolve) => {
            if (listComplete) {
                const availabilitiesList = listComplete.availabilities;
                const regionList = listComplete.regions;

                if (availabilitiesList) {
                    if (availabilitiesList.length > 0 && !availabilitiesList.some((i) => i.availabilityCode === "%")) {
                        if (IsEnglish()) {
                            availabilitiesList.unshift({ availabilityCode: "%", descriptionE: "Select all" });
                        } else {
                            availabilitiesList.unshift({ availabilityCode: "%", descriptionF: "Sélectionner tous" });
                        }
                    }

                    if (availabilitySplit != null) {
                        const availabilitesFilter = availabilitiesList.filter((i) => availabilitySplit.includes(i.availabilityCode));
                        manageAvailabilityChange(availabilitesFilter, availabilitiesList);
                    }
                }
                
                setAvailbilites(availabilitiesList);
            }

            resolve();
        })
    };

    const loadRegions = (regionSplit) => {
        return new Promise(async (resolve) => {
            if (listComplete) {
                const regionsList = listComplete.regions;

                if (regionsList) {
                    if (regionsList.length > 0 && !regionsList.some((i) => i.regionCode === "%")) {
                        if (IsEnglish()) {
                            regionsList.unshift({ regionCode: "%", descriptionE: i18next.t('common:selectAll') });
                        } else {
                            regionsList.unshift({ regionCode: "%", descriptionF: i18next.t('common:selectAll') });
                        }
                    }

                    if (regionSplit != null) {
                        const regionsFilter = regionsList.filter((i) => regionSplit.includes(i.regionCode));
                        manageRegionChange(regionsFilter, regionsList);
                    }
                }
                
                setRegions(regionsList);
            }
            
            resolve();
        })
    };

    const tagRender = (tagData) => <div key={1} className={classes.formControl + ' k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base'}>{tagData.text}</div>;

    return (
        <LoadingLayer isActive={isProcessing}>
            <div className={styles.detailProfil}>
                <TableContainer className={classes.rootTable}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:additionalInformation.form.language')}</StyledFirstTableCell>
                                <StyledSecondTableCell>
                                    <GreenRadio
                                        checked={language === 'F'}
                                        onChange={handleLanguage}
                                        value="F"
                                        name="language"
                                    />
                                    {i18next.t('Language:french')}
                                    <br />
                                    <GreenRadio
                                        checked={language === 'A'}
                                        onChange={handleLanguage}
                                        value="A"
                                        name="language"
                                    />
                                    {i18next.t('Language:english')}
                                </StyledSecondTableCell>
                            </TableRow>
                            {flagReceiptSlips && <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:additionalInformation.form.receiptSlips')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{receiptSlips}</StyledSecondTableCell>
                            </TableRow>}
                            {flagCommunicationPreference && <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:additionalInformation.form.communicationPreference')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{communicationPreference}</StyledSecondTableCell>
                            </TableRow>}
                            {flagFullTime &&
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t('profile:additionalInformation.form.fullTime')}</StyledFirstTableCell>
                                    <StyledSecondTableCell>
                                        <FormControlLabel
                                            className={classes.formControl }
                                            control={<Checkbox checked={availableFullTime} onChange={handleAvailableFullTimeClick} name="availableFullTime" />}
                                            label={i18next.t('profile:additionalInformation.form.availableFullTime')}
                                        />
                                        {(availableFullTime)  &&
                                            <div className={classes.formControl}>
                                                <label className={classes.labelMulti + ' required' }>{i18next.t('profile:additionalInformation.form.availability')}</label>
                                                <MultiSelect
                                                    data={availabilities}
                                                    onChange={onAvailabilityChange}
                                                    value={availabilityValueList}
                                                    autoClose={false}
                                                    placeholder={i18next.t('profile:additionalInformation.form.availabilityChoose')}
                                                    dataItemKey="availabilityCode"
                                                    textField={IsEnglish() ? "descriptionE" : "descriptionF"}
                                                    tags={
                                                        availabilitiesSelected > 0
                                                            ? [
                                                                {
                                                                    text: `${availabilitiesSelected === availabilities.length ? availabilitiesSelected - 1 : availabilitiesSelected} ${i18next.t('common:selectedItems')}`,
                                                                    data: [...availabilityValueList],
                                                                },
                                                            ]
                                                            : []
                                                    }
                                                    tagRender={tagRender}
                                                />
                                                <label className={classes.labelMulti + ' required'}>{i18next.t('profile:additionalInformation.form.region')}</label>
                                                <MultiSelect
                                                    data={regions}
                                                    onChange={onRegionChange}
                                                    value={regionValueList}
                                                    autoClose={false}
                                                    placeholder={i18next.t('profile:additionalInformation.form.regionChoose')}
                                                    dataItemKey="regionCode"
                                                    textField={IsEnglish() ? "descriptionE" : "descriptionF"}
                                                    tags={
                                                        regionSelected > 0
                                                            ? [
                                                                {
                                                                    text: `${regionSelected === regions.length ? regionSelected - 1 : regionSelected} ${i18next.t('common:selectedItems')}`,
                                                                    data: [...regionValueList],
                                                                },
                                                            ]
                                                            : []
                                                    }
                                                    tagRender={tagRender}
                                                />
                                                <FormControlLabel
                                                    className={classes.formControlReserve}
                                                    control={<Checkbox checked={isReserve} onChange={handleIsReserveClick} name="isReserve" />}
                                                    label={i18next.t('profile:additionalInformation.form.isReserve')}
                                                />
                                            </div>
                                        }
                                    </StyledSecondTableCell>
                                </TableRow>
                            }
                            {flagOnCall &&
                                <TableRow>
                                    <StyledFirstTableCell>{i18next.t('profile:additionalInformation.form.onCall')}</StyledFirstTableCell>
                                    <StyledSecondTableCell>
                                        <FormControlLabel
                                            className={classes.formControl}
                                            control={<Checkbox checked={onCall} onChange={handleOnCallClick} name="ckOnCall" />}
                                        />
                                    </StyledSecondTableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="divButtons" style={{ padding: '0px 13px' }}>
                    <Button className="saveButton" onClick={handleSave} variant="success">
                        {i18next.t('buttons:save')}
                    </Button>
                </div>
                <AlertAlgo ref={alertRef} />
            </div>
            <Dialog
                open={openConfirmationOnCall}
                onClose={handleCloseConfirmOnCall}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    {i18next.t('profile:message.warning')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {onCall ? i18next.t('profile:additionalInformation.message.confirmNotOnCallChoice') : i18next.t('profile:additionalInformation.message.confirmOnCallChoice')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmOnCall} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('common:no')}
                    </Button>
                    <Button autoFocus onClick={handleConfirmOnCallClick} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('common:yes')}
                    </Button>
                </DialogActions>
            </Dialog>
        </LoadingLayer>
    );
}

export default withNamespaces(['Language', 'profile', 'buttons', 'common'], { wait: true })(AdditionalInfoForm);